import { SiteFiltersStore } from "../store";

export function updateSiteLabels(siteLabels: string[], store: SiteFiltersStore) {
  store.siteLabels = siteLabels;
}
